import { windowNamespaceObject } from "../namespace";
import { DefaultPluginLoader } from "./DefaultPluginLoader";
import { PluginRegistry } from "./PluginRegistry";
const PLUGIN_LOADER_REGISTRY_NS_NAME = "pluginLoaderRegistry";
/**
 * registers the given plugin loader.
 *
 * @param loader - the plugin loader to register
 */
export const registerPluginLoader = (loader) => {
    const registry = windowNamespaceObject(PLUGIN_LOADER_REGISTRY_NS_NAME);
    if (registry[loader.getStrategyName()]) {
        throw new Error(`Plugin loader with Name ${loader.getStrategyName()} already registered`);
    }
    registry[loader.getStrategyName()] = loader;
};
/**
 * initiates and returns the plugin loader by the given strategy name.
 *
 * @param strategy - strategy name to get a plugin loader for.
 */
export const getPluginLoader = (strategy = DefaultPluginLoader.NAME) => {
    const registry = windowNamespaceObject(PLUGIN_LOADER_REGISTRY_NS_NAME);
    if (!registry[strategy]) {
        throw new Error(`No plugin loader registered for the given strategy with Name ${strategy}.`);
    }
    const loader = registry[strategy];
    loader.init(PluginRegistry.getInstance());
    return loader;
};
//# sourceMappingURL=PluginLoader.js.map